import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const apiCall = async (method, url, data = null) => {
  const token = localStorage.getItem('token');
  const config = {
    method,
    url: `${API}${url}`,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  };
  if (data) config.data = data;
  return axios(config);
};

const EmailSubscriptionPopup = ({ onClose }) => {
  const [preferences, setPreferences] = useState({
    new_chapters: true,
    author_updates: true,
    weekly_digest: true
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await apiCall('post', '/profile/email-preferences', {
        subscribed: true,
        ...preferences
      });
      // Mark popup as shown
      localStorage.setItem('email_popup_shown', 'true');
      onClose();
    } catch (error) {
      console.error('Failed to save preferences:', error);
    }
    setSaving(false);
  };

  const handleSkip = () => {
    localStorage.setItem('email_popup_shown', 'true');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-dark-card rounded-2xl max-w-md w-full p-6 border border-purple-500/30 shadow-2xl animate-fade-in">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">📧</span>
          </div>
          <h2 className="text-2xl font-bold text-dark-text mb-2">Stay Updated!</h2>
          <p className="text-dark-text-secondary text-sm">
            Never miss a new chapter from your favorite stories
          </p>
        </div>

        {/* Options */}
        <div className="space-y-4 mb-6">
          <label className="flex items-center gap-3 p-3 bg-dark-bg rounded-lg cursor-pointer hover:bg-dark-bg/70 transition-colors">
            <input
              type="checkbox"
              checked={preferences.new_chapters}
              onChange={(e) => setPreferences(prev => ({ ...prev, new_chapters: e.target.checked }))}
              className="w-5 h-5 accent-purple-500 rounded"
            />
            <div className="flex-1">
              <span className="text-dark-text font-medium">📖 New Chapter Alerts</span>
              <p className="text-dark-text-secondary text-xs">Get notified when stories in your library update</p>
            </div>
          </label>

          <label className="flex items-center gap-3 p-3 bg-dark-bg rounded-lg cursor-pointer hover:bg-dark-bg/70 transition-colors">
            <input
              type="checkbox"
              checked={preferences.author_updates}
              onChange={(e) => setPreferences(prev => ({ ...prev, author_updates: e.target.checked }))}
              className="w-5 h-5 accent-purple-500 rounded"
            />
            <div className="flex-1">
              <span className="text-dark-text font-medium">✍️ Author Updates</span>
              <p className="text-dark-text-secondary text-xs">Updates from your favorite authors</p>
            </div>
          </label>

          <label className="flex items-center gap-3 p-3 bg-dark-bg rounded-lg cursor-pointer hover:bg-dark-bg/70 transition-colors">
            <input
              type="checkbox"
              checked={preferences.weekly_digest}
              onChange={(e) => setPreferences(prev => ({ ...prev, weekly_digest: e.target.checked }))}
              className="w-5 h-5 accent-purple-500 rounded"
            />
            <div className="flex-1">
              <span className="text-dark-text font-medium">📬 Weekly Digest</span>
              <p className="text-dark-text-secondary text-xs">Trending stories and personalized recommendations</p>
            </div>
          </label>
        </div>

        {/* Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleSave}
            disabled={saving}
            className="w-full bg-gradient-to-r from-purple-500 to-pink-500 text-white py-3 rounded-lg font-semibold hover:opacity-90 transition-opacity disabled:opacity-50"
          >
            {saving ? 'Saving...' : '✓ Subscribe to Updates'}
          </button>
          <button
            onClick={handleSkip}
            className="w-full text-dark-text-secondary hover:text-dark-text py-2 text-sm transition-colors"
          >
            Maybe Later
          </button>
        </div>

        {/* Footer Note */}
        <p className="text-center text-dark-text-secondary text-xs mt-4">
          You can unsubscribe anytime from the link in our emails
        </p>
      </div>
    </div>
  );
};

export default EmailSubscriptionPopup;
